import { useCallback, useEffect, useState } from 'react'
import { normalizePanelPreferences, readPanelPreferences, writePanelPreferences } from './processLibraryPanelPreferences'

/** RN-04.1: the panel's preferences, read once from the browser and written back on every change. */
export const useProcessLibraryPanelPreferences = () => {
  const [preferences, setPreferences] = useState(readPanelPreferences)
  useEffect(() => {
    writePanelPreferences(preferences)
  }, [preferences])
  const updatePreferences = useCallback((patch) => {
    setPreferences((current) => normalizePanelPreferences({ ...current, ...patch }))
  }, [])
  return [preferences, updatePreferences]
}
